import type { ListColumn, ListSort, ListSortState } from "@/base/list/types";
import { formatShortDate } from "@/lib/listFormat";

// The sort the record lists share (Nav, 2026-09-27): Last modified, the
// default, or Date created, newest or oldest first, with a date column that
// shows whichever date the list is sorted by. Accounts (BRK-S211) and
// Submissions (BRK-S254) use it; PMS sorts both by `updatedAt` or `createdAt`
// (PMS-S588, PMS-S589).

export const MODIFIED_OR_CREATED_SORT: ListSort = {
  field: { urlKey: "sort", apiParam: "field" },
  dir: { urlKey: "dir", apiParam: "dir" },
  options: [
    { value: "updatedAt", label: "Last modified" },
    { value: "createdAt", label: "Date created" },
  ],
  default: { field: "updatedAt", dir: "desc" },
};

/** The date the list shows and sorts by: last modified unless the broker
 *  sorted by date created. */
export function sortedDateField(
  sort?: ListSortState,
): "updatedAt" | "createdAt" {
  return sort?.field === "createdAt" ? "createdAt" : "updatedAt";
}

/** The date column, headed by the date it shows. */
export function sortedDateColumn<
  Row extends { updatedAt?: string; createdAt?: string },
>(): ListColumn<Row> {
  return {
    id: "date",
    header: (view) =>
      sortedDateField(view.sort) === "createdAt"
        ? "Date created"
        : "Last modified",
    cell: (row, view) => formatShortDate(row[sortedDateField(view.sort)]),
  };
}
